import React, { Component } from "react";
import { Grid, Button, GridColumn, Icon, Dropdown } from "semantic-ui-react";
import PeriodSlider from "./PeriodSlider";
import EventSlider from "./EventSlider";
import EventSliderIndex from "./EventSliderIndex";
import EventSliderIndexPeriod from "./EventSliderIndexPeriod";
import EventsCategoryIndicator from "../Shared/EventsCategoryIndicator";
import OwlCarousel from "react-owl-carousel2";
import { FixedSizeList as List } from "react-window";
import { Link } from "react-router-dom";
import axios from "axios";
import { BrowserView, MobileView, isBrowser, isMobile, isMobileOnly, isTablet, withOrientationChange } from "react-device-detect";
const timelineData = require("./../timeline_data.json");
const timeline_periods = require("./../timeline_periods.json");
const timeline_category = require("./../timeline_category.json");
const timelineperiods = require("./../timelineperiods.json");
const { apiUrl } = require('./config')
// static file from endpoints
// const timeline_data = require("./../timeline_data.json");
// const timeline_periods = require("./../timeline_periods.json");
// const timeline_category = require("./../timeline_category.json");
// const timelineperiods = require("./../timelineperiods.json");

var _ = require('lodash');
const { 
  getCategory,
  fontSizeOptions,
  fontSizeTitle,
  fontSizeCategory,
  fontSizeDesc,
  ImageSizeOptions,
  getMonthName
} = require("../Shared/utils");

  function go() {
    var querystring = window.location.search.replace(/^\?/, '');
    // console.log('querystring', querystring)
    var params = {};
    querystring.replace(/([^=&]+)=([^&]*)/g, function (m, key, value) {
    params[decodeURIComponent(key)] = decodeURIComponent(value);
    });
    const token = encodeURIComponent(params['token'])
    // console.log('token', token)
    const content_type = encodeURIComponent(params['content_type'])
    // console.log('content_type', content_type)
    return `${apiUrl}/api/v2/page_preview/1/?content_type=${content_type}&token=${token}&format=json`
   }

  function isEmpty(obj) {
    for (var key in obj) {
      if (obj.hasOwnProperty(key)) return false;
    }
    return true;
  }

  function timelineListShowEvent() {
    return `${apiUrl}/api/v2/pages/?type=home.TimelineEvent&fields=*&show_event=true&limit=10000`
  }


  function getStaticData() {
    var url = `${apiUrl}/staticfiles/content/timeline_data.json`
    // console.log("urlurlurl", url)
    return axios.get(url)
      .then(res => {
        // console.log("resssss", res)
        const data = res.data;
          return data
      })
      .catch(error => {
        console.error(error);
      });
  }

  function getStaticPeriods() {
    var url = `${apiUrl}/staticfiles/content/timeline_periods.json`
    return axios.get(url)
      .then(res => {
        const data = res.data;
          return data
      })
      .catch(error => {
        console.error(error);
      });
  }

  function getStaticCategory() {
    var url = `${apiUrl}/staticfiles/content/timeline_category.json`
    return axios.get(url)
      .then(res => {
        const data = res.data;
          return data
      })
      .catch(error => {
        console.error(error);
      });
  }

  function getStaticTimelinePeriods() {
    var url = `${apiUrl}/staticfiles/content/timelineperiods.json`
    return axios.get(url)
      .then(res => {
        const data = res.data;
          return data
      })
      .catch(error => {
        console.error(error);
      });
  }
 
  function timelinePreview(url) {
    return axios.get(url)
      .then(res => {
        const data = res.data;
        // console.log("datadatadata",data)
          return data
      })
      .catch(error => {
        console.error(error);
      });
  }

class TimelineIndexPeriod extends Component {
   state = {
     eventItem: {},
     timelineData: [],
     timelinePeriods: [],
     isOpen: false,
     result: '',
     openDiv: false,
     closeDiv: true,
     eventIds: [],
     activePeriodId: 0,
     activeCategoryId: 0,
     activeCategoryName: '',
     activeEventId: 0, 
     activeNavId: 0
   }

  componentWillMount = () => {
    // console.log("propsPeriodEventMountPeriodzz", this.props);

    if(this.props.location.state != null) {
      this.setState({
        activePeriodId: this.props.location.state.periodId,
        activeCategoryId: this.props.location.state.categoryId,
        activeEventId: this.props.location.state.eventId,
        activeCategoryName: this.props.location.state.categoryName,
      })
    }

    var tempSort =_.sortBy(timelineData, [function(o) { return parseInt(o.period_id); }]);

    var urlPreview = go()
    // console.log("urlPreview", urlPreview)

    // static data
    var copyData = tempSort
    // console.log("urlPreview", urlPreview)
    // timelinePreview(urlPreview).then( resData => {
    //     console.log("timelinePreview", resData)
    //     copyData.map((item)=>{
    //         if(item.period_id == resData.period_id){
    //             item['description'] = resData.description
    //             item['background_image'] = resData.background_image
    //             item['background_image_category'] = resData.background_image_category
    //             item['description'] = resData.description
    //             item['end_year'] = resData.end_year
    //             item['id'] = resData.id
    //             item['period_color'] = resData.period_color
    //             item['period_id'] = resData.period_id
    //             item['period_image'] = resData.period_image
    //             item['period_name'] = resData.period_name
    //             item['period_slider_display_name'] = resData.period_slider_display_name
    //             item['start_year'] = resData.start_year
    //             item['title'] = resData.title
    //         }
    //     })
    //     var arrVol = []
    //     timeline_category.map((item)=>{
    //         var obj = { key: item.name, text: item.name, value: item.name }
    //         arrVol.push(obj)
    //     })
    //     this.setState({
    //       timelineData: copyData,
    //       timelineDataCopy: copyData,
    //       periods: timeline_periods,
    //       volumes: timeline_category,
    //       timelinePeriods: timelineperiods,
    //       optionsVolume: arrVol
    //     });
    // })


    timelinePreview(urlPreview).then( resData => {
      getStaticData().then( data => {
        getStaticCategory().then(vol => {
          getStaticPeriods().then(per => {
            getStaticTimelinePeriods().then(periods => {
              // console.log("timelinePreview", resData)
              resData.sub_period.map(item => {
                item.value.category_page.event_list.map(ev => {
                  ev.value.event.map(i => {
                    var cats = JSON.parse(i.event.categories)
                    var start_month = i.event.dates[0].month == "" ? ""  : getMonthName(i.event.dates[0].month) + " "
                    var start_month_value = i.event.dates[0].month == "" ? ""  : i.event.dates[0].month
                    var start_month_day = i.event.dates[0].day == "" ? ""  : i.event.dates[0].day
                    var start_day = i.event.dates[0].day == "" ? "" : i.event.dates[0].day
                    var start_day_complete = i.event.dates[0].day == "" ? "" : i.event.dates[0].day + ", "
                    var start_year = i.event.dates[0].year == "" ? "" : i.event.dates[0].year
                    i.event['categories'] = JSON.parse(i.event.categories)
                    i.event['periods'] = JSON.parse(i.event.periods)
                    if(cats == null || cats.length == 0){
                      i.event['categoryId'] = ''
                      i.event['category'] = ''
                    }else{
                      i.event['categoryId'] = cats[0].pk
                      i.event['category'] = cats[0]
                    }
                     i.event['start_month_value'] = start_month_value
                     i.event['start_day_value'] = start_month_day
                     i.event['start_year'] = start_year
                     i.event['start_date'] = start_month + start_day
                     i.event['complete_start_date'] = start_month +  start_day_complete + start_year
                     i.event['periodId'] = i.event.periods[0].fields.name
                     i.event['periodName'] = i.event.periods[0].pk
                  })
                })
              })
              // console.log("resData", resData)
              data.map((item)=>{
                  if(item.period_id == resData.period_id){
                      item['description'] = resData.description
                      item['background_image'] = resData.background_image
                      item['background_image_category'] = resData.background_image_category
                      item['description'] = resData.description
                      item['end_year'] = resData.end_year
                      item['id'] = resData.id
                      item['period_color'] = resData.period_color
                      item['period_id'] = resData.period_id
                      item['period_image'] = resData.period_image
                      item['period_name'] = resData.period_name
                      item['period_slider_display_name'] = resData.period_slider_display_name
                      item['start_year'] = resData.start_year
                      item['title'] = resData.title
                      item['sub_period'] = resData.sub_period
                  }
              })

              var arrVol = []
              vol.map((item)=>{
                  var obj = { key: item.name, text: item.name, value: item.name }
                  arrVol.push(obj)
              })
              this.setState({
                timelineData: data,
                timelineDataCopy: data,
                periods: per,
                volumes: vol,
                timelinePeriods: periods,
                optionsVolume: arrVol
              });
            })
          })

        })
      })
    })
  }

  openNav = (e) => {
    this.setState({
      sideBarMenu: true
    })
  }

  openSideBarFilter = (e) => {
    this.setState({
      sideBarMenuFilter: true
    })
  }

  closeNav = (e) => {
    this.setState({
      sideBarMenu: false,
      sideBarMenuFilter: false
    })
  }

  toggleDivOpen = (e) => {
    // console.log('eventid', e)
    var that = this
    var eventIds = []
    this.state.eventIds.push(e)

    var newArray = that.state.eventIds.filter(function(elem, pos) {
          return that.state.eventIds.indexOf(elem) == pos;
    });

    this.setState({
      openDiv: true,
      openEventId: e,
      eventIds: newArray
    });
  }


  toggleDivClose = (e) => {
    var that = this
    var newArray = that.state.eventIds.filter(function(elem, pos) {
          return that.state.eventIds.indexOf(elem) == pos;
    });
    // console.log("newArray", newArray)
     // remove item in array
    const items = ['a', 'b', 'c', 'd', 'e', 'f']
    const valueToRemove = e
    const filteredItems = newArray.filter(item => item !== valueToRemove)

    // console.log("filteredItems", filteredItems)
    // console.log('eventid', e)
    this.setState({
      openDiv: false,
      openEventId: e, 
      closeDiv: false,
      eventIds: filteredItems
    });
  }

  handleNavClick = (periodId, categId, categName, resId) => {
    // console.log('handleNavClickhandleNavClick', periodId, categId, categName, resId)

    this.setState({
      activeCategoryId: categId,
      activePeriodId: periodId,
      activeCategoryName: categName
    }, () => {
      // This code will run after the state has been updated
      const targetElement = document.getElementById(resId);
      const targetOffset = targetElement.offsetTop;
      
      // console.log('targetOffset', targetOffset);
      // console.log('targetElement', targetElement);
    
      // window.scrollTo({
      //   top: targetOffset,
      //   behavior: 'smooth'
      // });
    });
  }


  render() {
    // console.log("states", this.state);
    return (
      <div className=''> 
        <PeriodCoverIndex {...this.state} 
          handleOpenNav = {this.openNav}
          handleCloseNav = {this.closeNav}
          toggleDivOpen = {this.toggleDivOpen}
          toggleDivClose = {this.toggleDivClose}
          handleNavClick = {this.handleNavClick}
          />
        {/* <EventSlider {...this.state}/> */}
      </div>
    );
  }
}

export default TimelineIndexPeriod;

const PeriodCoverIndex = props => {
  // console.log("PeriodCoverxx", props);
  const { timelineData, periods, volumes, timelinePeriods } = props;
  const options = {
    items: 5,
    nav: true,
    rewind: true,
    navText: ["<div class='period-arrow-slider'><i class='arrow-slider lead-5 pr-1 fa fa-chevron-left text-gold carousel-icon rounded-circle' aria-hidden='true'></i></div>", 
    "<div class='period-arrow-slider'><i class='arrow-slider lead-5 pl-1 fa fa-chevron-right text-gold carousel-icon rounded-circle' aria-hidden='true'></i></div>"],
    responsive:{
      0:{
          items:1,
          nav: true,
          dots: false,
          navText: ["<div class='period-arrow-slider'><i class='arrow-slider lead-5 pr-1 fa fa-chevron-left text-gold carousel-icon rounded-circle' aria-hidden='true'></i></div>", 
    "<div class='period-arrow-slider'><i class='arrow-slider lead-5 pl-1 fa fa-chevron-right text-gold carousel-icon rounded-circle' aria-hidden='true'></i></div>"],
      },
      600:{
          items:3,
          nav: true,
          dots: false,
          navText: ["<div class='period-arrow-slider'><i class='arrow-slider lead-5 pr-1 fa fa-chevron-left text-gold carousel-icon rounded-circle' aria-hidden='true'></i></div>", 
    "<div class='period-arrow-slider'><i class='arrow-slider lead-5 pl-1 fa fa-chevron-right text-gold carousel-icon rounded-circle' aria-hidden='true'></i></div>"],
      },
      1000:{
          items:5,
          nav:true,
          loop:false,
          dots: false,
          navText: ["<div class='period-arrow-slider'><i class='arrow-slider lead-5 pr-1 fa fa-chevron-left text-gold carousel-icon rounded-circle' aria-hidden='true'></i></div>", 
    "<div class='period-arrow-slider'><i class='arrow-slider lead-5 pl-1 fa fa-chevron-right text-gold carousel-icon rounded-circle' aria-hidden='true'></i></div>"],
      },
      1024:{
          items:4,
          nav:true,
          loop:false,
          dots: false,
          navText: ["<div class='period-arrow-slider'><i class='arrow-slider lead-5 pr-1 fa fa-chevron-left text-gold carousel-icon rounded-circle' aria-hidden='true'></i></div>", 
    "<div class='period-arrow-slider'><i class='arrow-slider lead-5 pl-1 fa fa-chevron-right text-gold carousel-icon rounded-circle' aria-hidden='true'></i></div>"],
      },
      1281:{
          items:5,
          nav:true,
          loop:false,
          dots: false,
          navText: ["<div class='period-arrow-slider'><i class='arrow-slider lead-5 pr-1 fa fa-chevron-left text-gold carousel-icon rounded-circle' aria-hidden='true'></i></div>", 
    "<div class='period-arrow-slider'><i class='arrow-slider lead-5 pl-1 fa fa-chevron-right text-gold carousel-icon rounded-circle' aria-hidden='true'></i></div>"],
      },
      1921:{
          items:5,
          nav:true,
          loop:false,
          dots: false,
          navText: ["<div class='period-arrow-slider'><i class='arrow-slider lead-5 pr-1 fa fa-chevron-left text-gold carousel-icon rounded-circle' aria-hidden='true'></i></div>", 
    "<div class='period-arrow-slider'><i class='arrow-slider lead-5 pl-1 fa fa-chevron-right text-gold carousel-icon rounded-circle' aria-hidden='true'></i></div>"],
      }
    }
    //   autoplay: true
  };
  const menuClass = `dropdown-menu${props.isOpen ? " show" : ""}`;
  return (
    <div className="" style={{marginBottom: `${isMobile ? '0rem' : '13rem'}` }}> 
      {timelineData.map(item => {
        return (
          <div
            className="container-fluid col-xl-12 h-100 bg-img-fixed p-0"
            style={{
              backgroundImage: `url('${item.background_image == null ? '' : item.background_image.meta.download_url}')`,
              // backgroundColor: `${item.period_color+80}`,
              backgroundBlendMode: "soft-light"
            }}
          >
            <div className="" id={`id${item.id}`} name={`id${item.id}`}>
              <Grid className="m-0">
                <Grid.Column width={16} className="p-5 mt-3 text-center">
                  <div className="col-12">
                    {/* <p className="text-white text-uppercase small-2 font-sans-serif-Roboto font-weight-bold period-header">
                      Digital Index
                    </p> */}
              
                  </div>
                  <div className="pt-3">
                    <p className="text-white font-oswald-medium large-5 period-title-header sss">
                      {item.period_name}
                    </p>
                    <p className="text-white font-oswald-medium large-5 period-title-header opacity-normal">
                      {item.start_year}-{item.end_year}
                    </p>
                  </div>
                </Grid.Column>
                
                <Grid.Column width={16} className={`${isMobile ? 'pt-0 pb-0' : 'pt-5 pb-0'}`}>
                  <div className="row pr-2 pl-3">
                    <div className="col-md-5 p-0">
                      <img src={item.period_image.meta.download_url} className="period-image"/>
                    </div>
                    <div className="col-md-7 pr-0 text-left">
                    {/* <Link className="link-event" to={{
                      pathname: `/periodEvent/${item.period_id}`,
                      state: {
                        fromNotifications: true,
                        modal: true,
                        items: props.timelinePeriods,
                        periods: props.periods,
                        volumes: props.volumes
                      }
                      }}>
                      <Button
                        className="rounded-0 btn-period font-oswald p-1"
                        content="See Events"
                        icon="right arrow"
                        labelPosition="right"
                      /></Link> */}
                      <div>
                        <p className="text-white font-oswald-medium period-title mt-3 mr-5">
                          {item.period_title}
                        </p>
                        <div className="row mr-0">
                          <div className="col-md-12">
                            <p className="text-white font-roboto-medium period-description pr-5">
                              {item.description}
                            </p>
                            <div className="position-relative">
                              <a href={`#event${item.id}`}>  <Button
                                className="rounded-0 btn-period-scroll font-oswald p-1"
                                content="Scroll Down"
                              >
                                <Icon name="long arrow alternate left" />
                                Scroll Down
                              </Button></a>
                            
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </Grid.Column>
                </Grid>
                {isMobile ? 
                <div>
                  <div id="mySidenav" class={`sidenav ${props.sideBarMenu == true ? 'sidenav w-100 zIndex-999 text-center pl-4 pr-4' : ''}`}>
                    <a href="javascript:void(0)" class="closebtn" onClick={props.handleCloseNav}>&times;</a>
                    <h5 className="text-white mb-2">Timeline Periods</h5>
                    <div className="row">
                        {props.timelineData.map(item => {
                          return (
                            <div className="col-12 col-lg-12 col-md-6 col-sm-6 p-0 m-auto">
                            <a className="" href={`#id${item.id}`} onClick={props.handleCloseNav}>
                              <div className="">
                                <div
                                  className="position-relative"
                                  style={{
                                    // backgroundColor: `${item.period_color}`
                                  }}>
                                  <img className="period-slider-img-menu" src={item.period_slider_thumbnail == null ? item.background_image == null ? '' : item.background_image.meta.download_url : item.period_slider_thumbnail.meta.download_url} />
                                  <div className="center-div period-slider-title font-oswald bg-black-light text-white">
                                    {item.period_slider_display_name}
                                    <p>({item.start_year}-{item.end_year})</p>
                                  </div>
                                </div>
                              </div>
                            </a>
                            </div>
                          );
                        })}
                    </div>
                  </div>

                  <Button circular className="sidenav-btn-left" icon='bars' onClick={props.handleOpenNav}/>
                </div> 
                : 
                <div>
                  <Grid className="m-0">
                  <Grid.Column width={16} className="period_slider sss p-2">
                    <div>
                      <OwlCarousel loop margin={10} options={options}>
                        {props.timelineData.map(item => {
                          return (
                            <a href={`#id${item.id}`}>
                              <div className="p-2">
                                <div
                                  className="position-relative"
                                  style={{
                                    // backgroundColor: `${item.period_color}`
                                  }}>
                                  <img className="period-slider-img" src={item.period_slider_thumbnail == null ? item.background_image == null ? '' : item.background_image.meta.download_url : item.period_slider_thumbnail.meta.download_url} />
                                  <div className="center-div period-slider-title font-oswald bg-black-light text-white">
                                    {item.period_slider_display_name}
                                    <p>({item.start_year}-{item.end_year})</p>
                                  </div>
                                </div>
                              </div>
                            </a>
                          );
                        })}
                      </OwlCarousel>
                    </div>
                  </Grid.Column>
                  </Grid>
                </div>
                }
            </div>
            <Grid className="m-0 events" style={{ backgroundColor: "rgba(0, 0, 0, 0.80)" }}>
              {/* <Grid.Column width={2} className="p-5"></Grid.Column> */}
              <Grid.Column width={16} className={`pt-0 pb-5 pr-0 pl-0 ${item.sub_period.length == 0 ? 'd-none': 'd-block'}`} id={`event${item.id}`}>
                <EventsNewOneColumnV62
                // eventList={item.list} 
                eventListNew={item.sub_period} 
                periods={periods}
                volumes={volumes}
                timelineData={timelineData}
                timelinePeriod={item}
                result = {props.result}
                toggleDivOpen = {props.toggleDivOpen}
                openDiv = {props.openDiv}
                openEventId = {props.openEventId}
                toggleDivClose = {props.toggleDivClose}
                closeDiv = {props.closeDiv}
                eventIds = {props.eventIds}
                activePeriodId = {props.activePeriodId}
                activeCategoryId = {props.activeCategoryId}
                activeEventId = {props.activeEventId}
                activeCategoryName = {props.activeCategoryName}
                handleNavClick = {props.handleNavClick}
                />
                
                {/* <EventItem eventItem={eventItem} /> */}
              </Grid.Column>
            </Grid>
        </div>
        );
      })}
    </div>
  );
};

const EventsNewOneColumnV62 = props => {
  // console.log("eventsprops", props);
  return (
    <div class="">

<section id="tabs">
	<div class="">
		<div class="">
     
    <nav className={`tabbable bg-dark-gray ${isMobileOnly ? 'p-3': ''}`} id="tabbable" style={{
              // backgroundColor: `${props.timelinePeriod.period_color}`,
              backgroundBlendMode: "soft-light"
            }}>
        <div className={`nav nav-tabs nav-fill tabbable-nav m-auto ${props.eventListNew.length > 2 && isMobileOnly ? '': 'nav-center'}`} role="tablist">
          {props.eventListNew.map((item, ind)=>{
            // console.log("dsdsdsd", item, ind)
            const resCat = item.value.category_page.categories[0].name.replace(/ /g, '').toLowerCase()
            const resId = resCat + item.id + ind    
            return (
                  <li class="" id={`tab-${resCat + item.id + ind}`} data-toggle="tab" href={`#${resCat + item.id + ind}`} role="tab" aria-controls={`${resCat + item.id + ind}`} aria-selected="true" onClick={props.handleNavClick.bind(this, props.timelinePeriod.id, item.value.category_page.categories[0].id, item.value.category_page.categories[0].name, resId )}>
                    {props.activePeriodId == 0 || props.activePeriodId != props.timelinePeriod.id ?
                      <a className={`nav-item nav-link period-category mx-1 ${ind == 0 ? 'active' : ''}`}>
                        <h3 className="event-category font-oswald-medium">{item.value.category_page.categories[0].name}</h3>
                      </a>
                      :
                      <a className={`nav-item nav-link period-category mx-1 acc ${props.activePeriodId == props.timelinePeriod.id && props.activeCategoryName.toLowerCase() == item.value.category_page.categories[0].name.toLowerCase() ? "active" : ""}`}>
                        <h3 className="event-category font-oswald-medium">{item.value.category_page.categories[0].name}</h3>
                      </a>
                    }
                  </li>
                )
          })}
        </div>
      </nav>
			<div className="text-white m-auto col-xl-8 col-lg-10 col-md-16">
				<div class="tab-content mb-3 mt-4" id="nav-tabContent" style={{paddingBottom: "7rem"}}>
        {props.eventListNew.map((item, ind)=>{
          const resCat = item.value.category_page.categories[0].name.replace(/ /g, '').toLowerCase()
          // console.log("ressssss",resCat)
          // console.log("ressssssitemitem",item)

          let classVar = ''
          if(props.activePeriodId == "" || props.activePeriodId != props.timelinePeriod.id) {
              classVar = `tab-pane fade show ${ind == 0 ? 'active' : ''}`
          }else{
              classVar = `tab-pane fade show acc ${props.activePeriodId == props.timelinePeriod.id && props.activeCategoryName.toLowerCase() == item.value.category_page.categories[0].name.toLowerCase() ? "active" : ""}`
          }
          

          return (
            <div class={`${classVar}`} id={`${resCat + item.id + ind}`} role="tabpanel" aria-labelledby={`tab-${resCat + item.id + ind}`}>
              
              {/* {props.activePeriodId == "" ? ind == 0 ? 'active ind' : 'not active ind' :  props.activePeriodId == props.timelinePeriod.id && props.activeCategoryName.toLowerCase() == item.value.category_page.categories[0].name.toLowerCase() ? "active active" : "not active active" } */}
              
              {item.value.category_page.event_list.map(i => {
              // console.log('ccscscs0', i)
              return (
                <div className="">
                  {/* <div className='event-year event-year-sticky text-white bg-gold rounded-0'>{i.value.date_divider}</div> */}
                  <div className={`${isMobileOnly ? 'event-year-one event-year-sticky text-white bg-gold rounded-0' : 'event-year event-year-sticky text-white bg-gold h-100'}`}>{i.value.date_divider}</div>
                    {i.value.event.map((x, ind) => {
                      // console.log('colscolscolscols', x)
                      return (
                        <div className="">
                          {isMobileOnly ?
                            <div className="mobile">
                              <Grid className="m-0">
                              <Grid.Column width={15} className="p-0 pb-0 m-auto event-desc-container">
                                {/* {x.map((cols,index) => { */}
                                  {/* return ( */}
                                    <div>
                                      {
                                        x.text_display == "under" ?
                                        <div>
                                        <div id={`event${ props.timelinePeriod.id + "-" + x.event.category.pk + "-" + x.event.id}`} name={`event${ props.timelinePeriod.id  + "-" + x.event.category.pk + "-" + x.event.id}`} style={{height: `${props.activeEventId == x.event.id ? '30px' : '0px'}` }}></div>
                                        <div  className={`mb-4`}>
                                                <div className={`${x.event_types == 'historical' ? 'content_right_icon text-gold': 'content_right_icon_sun text-gold'}`} data-toggle="tooltip" data-placement="top" title={x.event_types == 'historical' ? 'Historical Event': 'Artistic Event'}>{x.event_types == 'historical' ? <i class="fa fa-hourglass-start"></i>: <span class='icon-epa-sun'></span>}</div>
                                                <div className="pr-0 pb-0 pt-3">
                                                  <div className={`padding-05 pb-0 pt-0`}>
                                                  <div className="p-3" style={{filter: `${x.event_types == 'historical' ? 'none' : 'brightness(1.2)'}`, backgroundColor: `${x.event_types == 'historical' ? 'none' : props.timelinePeriod.period_color+60}`}}>
                                                    {x.event.photo == null || x.event.photo == "" ? "" :
                                                      <Link className="link-event" to={{
                                                        pathname: `/epa_timeline/eventSlider/${props.timelinePeriod.period_id}/${x.event.id}`,
                                                        state: {
                                                          fromNotifications: true,
                                                          modal: true,
                                                          items: props.timelineData,
                                                          periods: props.periods,
                                                          volumes: props.volumes
                                                        }
                                                      }}>
                                                        <div className="d-flow-root">
                                                          <img className="event-image pl-0" align="left" src={x.event.photo.url} />
                                                        </div>
                                                      </Link>
                                                    }
                                                    <Link className="link-event" to={{
                                                        pathname: `/epa_timeline/eventSlider/${props.timelinePeriod.period_id}/${x.event.id}`,
                                                        state: {
                                                          fromNotifications: true,
                                                          modal: true,
                                                          items: props.timelineData,
                                                          periods: props.periods,
                                                          volumes: props.volumes
                                                        }
                                                      }}>
                                                        <p className={`event-title-historical text-left text-gold-light pt-3 ${x.event.display_name == " " || x.event.display_name == null && x.event.complete_start_date == "" || x.event.complete_start_date == null ? "d-none" : 
                                                          "d-block"}`}>
                                                          {x.event.display_name == "" || x.event.display_name == null
                                                            ? x.event.complete_start_date
                                                            : x.event.display_name}
                                                          {/* <span className={`event-category ${item.value.category_page.categories[0].name == '' ? "d-none" : ""}`}>| {item.value.category_page.categories[0].name}</span> */}
                                                        </p>
                                                    </Link>
                                                    <div>
                                                    <p className={`text-left text-white my-2 event-description-historical font-style-3 ${fontSizeDesc(fontSizeOptions(x.font_size))}`}>
                                                        <div  dangerouslySetInnerHTML={{__html: x.event.description}} />
                                                      </p>
                                                    </div>
                                                  </div>
                                                  </div>
                                                </div>
                                        </div>
                                      </div>

                                        :
                                        <div>
                                        <div id={`event${ props.timelinePeriod.id + "-" + x.event.category.pk + "-" + x.event.id}`} name={`event${ props.timelinePeriod.id  + "-" + x.event.category.pk + "-" + x.event.id}`} style={{height: `${props.activeEventId == x.event.id ? '30px' : '0px'}` }}></div>
                                        <div className={`mb-4`}>
                                              <div className={`${x.event_types == 'historical' ? 'content_right_icon text-gold': 'content_right_icon_sun text-gold'}`} data-toggle="tooltip" data-placement="top" title={x.event_types == 'historical' ? 'Historical Event': 'Artistic Event'}>{x.event_types == 'historical' ? <i class="fa fa-hourglass-start"></i>: <span class='icon-epa-sun'></span>}</div>
                                              {/* <div className={`content_left content_left_one ${x.event_types == 'historical' ? 'bg-gold': 'bg-white'}`} data-toggle="tooltip" data-placement="top" title={item.value.category_page.categories[0].name}></div> */}
                                              <div className="pr-0 pb-0 pt-3">
                                                <div className={`padding-05 pb-0 pt-0`}>
                                                <div className="p-3" style={{filter: `${x.event_types == 'historical' ? 'none' : 'brightness(1.2)'}`, backgroundColor: `${x.event_types == 'historical' ? 'none' : props.timelinePeriod.period_color+60}`}}>
                                                  <Link className="link-event" to={{
                                                    pathname: `/epa_timeline/eventSlider/${props.timelinePeriod.period_id}/${x.event.id}`,
                                                    state: {
                                                      fromNotifications: true,
                                                      modal: true,
                                                      items: props.timelineData,
                                                      periods: props.periods,
                                                      volumes: props.volumes
                                                    }
                                                  }}>
                                                    <p className={`event-title-historical text-left text-gold-light ${x.event.display_name == " " || x.event.display_name == null && x.event.complete_start_date == "" || x.event.complete_start_date == null ? "d-none" : "d-block"}`}>
                                                      {x.event.display_name == "" || x.event.display_name == null
                                                        ? x.event.complete_start_date
                                                        : x.event.display_name}
                                                      {/* <span className={`event-category ${item.value.category_page.categories[0].name == '' ? "d-none" : ""}`}>| {item.value.category_page.categories[0].name}</span> */}
                                                    </p>
                                                  </Link>
                                                  <div>
                                                  <p className={`text-left text-white my-2 event-description-historical font-style-3 ${fontSizeDesc(fontSizeOptions(x.font_size))}`}>
                                                      <div  dangerouslySetInnerHTML={{__html: x.event.description}} />
                                                    </p>
                                                  </div>
                                                  {x.event.photo == null || x.event.photo == "" ? "" :
                                                  <Link className="link-event" to={{
                                                    pathname: `/epa_timeline/eventSlider/${props.timelinePeriod.period_id}/${x.event.id}`,
                                                    state: {
                                                      fromNotifications: true,
                                                      modal: true,
                                                      items: props.timelineData,
                                                      periods: props.periods,
                                                      volumes: props.volumes
                                                    }
                                                  }}>
                                                    <div className="d-flow-root">
                                                      <img className="event-image pl-0" align="left" src={x.event.photo.url} />
                                                    </div>
                                                  </Link>
                                                  }
                                                </div>
                                                </div>
                                              </div>
                                        </div>
                                      </div>
                                      }
                                    </div>
                                  {/* ) */}
                                {/* })} */}
                                </Grid.Column>
                                {/*<Grid.Column width={1} mobile={1} className="p-0 event-desc-container">
                                 {x.map((cols,index) => {
                                  return (
                                    <div>
                                      <EventsCategoryIndicator className={"event-marker-right"} category={item.value.category_page.categories[0].name} />
                                    </div>
                                  )
                                })} 
                                </Grid.Column>*/}
                              </Grid>
                            </div> 
                            :
                            <div>
                              <Grid className="mb-0">
                              <GridColumn width={12} className="p-0 m-auto event-desc-container">
                              {/* {x.map((cols,index) => {
                                console.log("colscols", cols)
                                  return ( */}
                                    <div>
                                      <div className="activeEvent" id={`event${ props.timelinePeriod.id + "-" + x.event.category.pk + "-" + x.event.id}`} name={`event${ props.timelinePeriod.id  + "-" + x.event.category.pk + "-" + x.event.id}`} style={{height: `${props.activeEventId == x.event.id ? '35px' : '0px'}` }}></div>

                                    <div className={`${x.event_types == 'historical' ? 'historical-event': 'specific-event'}`}>
                                     
                                    {/* <div className={`mt-5 tect ${x.event_display_options == "" || x.event_display_options == "text_display" ? '':'d-none'}`}> */}
                                        <div className={`mt-5 tect`}>
                                        <Link className="link-event" to={{
                                            pathname: `/epa_timeline/eventSlider/${props.timelinePeriod.period_id}/${x.event.id}`,
                                            state: {
                                              fromNotifications: true,
                                              modal: true,
                                              items: props.timelineData,
                                              periods: props.periods,
                                              volumes: props.volumes
                                            }
                                          }}>
                                          {/* <EventSliderIndexPeriod {...props} /> */}
                                          <div className={`${x.event_types == 'historical' ? 'content_right_icon text-gold': 'content_right_icon_sun text-gold'}`} data-toggle="tooltip" data-placement="top" title={x.event_types == 'historical' ? 'Historical Event': 'Artistic Event'}>{x.event_types == 'historical' ? <i class="fa fa-hourglass-start"></i>: <span class='icon-epa-sun'></span>}</div>
                                          {
                                            x.event_types == 'historical' ? 
                                            <div className="mb-2 pl-5 leftt">
                                              <div className={`padding-05 pt-0 pl-5`}>
                                              {/* <div className="p-2" style={{filter: `${x.event_types == 'historical' ? 'none' : 'brightness(1.2)'}`, backgroundColor: `${x.event_types == 'historical' ? 'none' : props.timelinePeriod.period_color+60}`}}>
                                                  <p className={`mb-0 text-left text-gold-light event-title-historical ${fontSizeTitle(fontSizeOptions(x.font_size))} ${x.event.display_name == "" && x.event.complete_start_date == "" || 
                                                  x.event.display_name == null && x.event.complete_start_date == "" || x.event.complete_start_date == null? "d-none" : 
                                                  "d-block"}`}>
                                                      {x.event.display_name == "" || x.event.display_name == null
                                                        ? x.event.complete_start_date
                                                        : x.event.display_name}
                                                      </p>
                                                    <div>
                                                      <p className={`text-left text-white event-description-historical font-style-3 1 ${fontSizeDesc(fontSizeOptions(x.font_size))}`}>
                                                        <div  dangerouslySetInnerHTML={{__html: x.event.description}} />
                                                      </p>
                                                    </div>
                                                    {x.event.photo == null || x.event.photo == "" ? "" :
                                                      <div className={`${x.image_display == 'd-block' ? '' : x.image_display == 'right' ? 'd-block' : x.image_display == 'center' ? 'd-block' : 'd-inline-block'}`}>
                                                        <img className={`event-image pl-0 pt-2 pb-0 pr-0 d-block ${x.image_display == 'left' ? '' : x.image_display == 'right' ? 'ml-auto' : x.image_display == 'center' ? 'mx-auto' : ''} ${ImageSizeOptions(x.image_size)}`} align="" src={x.event.photo.url} />
                                                      </div>
                                                    }

                                                </div> */}
                                                {
                                                  x.image_display == 'left' ? 
                                                  <div className="p-3 row xx historical-left-image" style={{filter: `${x.event_types == 'historical' ? 'none' : 'brightness(1.2)'}`, backgroundColor: `${x.event_types == 'historical' ? 'none' : props.timelinePeriod.period_color+60}`}}>
                                                      { x.event.photo == null || x.event.photo == "" ? "" :
                                                        <div className="">
                                                        {/* <div className="col-xl-6 col-lg-4 col-md-6 col-sm-6 px-0"> */}
                                                            <img className={`event-image pl-0 pt-2 pb-0 pr-0 d-block mx-auto ${x.image_display == 'left' ? '' : x.image_display == 'right' ? 'ml-auto' : x.image_display == 'center' ? 'mx-auto' : ''} ${ImageSizeOptions(x.image_size)}`} align="" src={x.event.photo.url} />
                                                        </div>
                                                      }
                                                      <div className=""> 
                                                      {/* <div className={`${x.event.photo == null || x.event.photo == "" ? "col-md-12 px-0" : "col-xl-6 col-lg-8 col-md-6 col-sm-6 px-0 pr-1"}`}>  */}
                                                        <div className={`${x.event.photo == null || x.event.photo == "" ? 'p-0' : x.text_display == 'bottom' ? 'p-3 position-absolute bottom-0 mb-3' : x.text_display == 'center' ? 'p-2 top-25 position-absolute m-auto' : 'pb-1 pt-2 pl-2'}`}>
                                                          <p className={`mb-0 text-left text-gold-light event-title-historical ${fontSizeTitle(fontSizeOptions(x.font_size))} ${x.event.display_name == "" && x.event.complete_start_date == "" || 
                                                            x.event.display_name == null && x.event.complete_start_date == "" || x.event.complete_start_date == null? "d-none" : 
                                                            "d-block"}`}>
                                                          {x.event.display_name == "" || x.event.display_name == null
                                                            ? x.event.complete_start_date
                                                            : x.event.display_name}
                                                            {/* <span className={`event-category ${fontSizeCategory(fontSizeOptions(item.font_size))} ${item.value.category_page.categories[0].name == '' ? "d-none" : ""}`}>| {item.value.category_page.categories[0].name}</span> */}
                                                          </p>

                                                          <p className={`text-left text-white event-description-historical font-style-3 7 left ${fontSizeDesc(fontSizeOptions(x.font_size))}`}>
                                                            <div  dangerouslySetInnerHTML={{__html: x.event.description}} />
                                                          </p>
                                                        </div>
                                                      </div>
                                                    </div>
                                                  :
                                                  x.image_display == 'right' ?
                                                  <div className="p-3 row" style={{filter: `${x.event_types == 'historical' ? 'none' : 'brightness(1.2)'}`, backgroundColor: `${x.event_types == 'historical' ? 'none' : props.timelinePeriod.period_color+60}`}}>
                                                      <div className={`${x.event.photo == null || x.event.photo == "" ? "col-md-12 px-0" : "col-xl-6 col-lg-8 col-md-6 col-sm-6 px-0 pr-1"}`}> 
                                                      <div className={`${x.event.photo == null || x.event.photo == "" ? 'p-0': x.text_display == 'under' ? 'pl-2 pt-1' :  x.text_display == 'bottom' ? 'p-3 position-absolute bottom-0' : x.text_display == 'center' ? 'p-2 top-25 position-absolute m-auto' : 'pb-1 pt-2 pl-2 pr-2'}`}>
                                                          <p className={`mb-0 text-left text-gold-light event-title-historical ${fontSizeTitle(fontSizeOptions(x.font_size))} ${x.event.display_name == "" && x.event.complete_start_date == "" || 
                                                            x.event.display_name == null && x.event.complete_start_date == "" || x.event.complete_start_date == null? "d-none" : 
                                                            "d-block"}`}>
                                                          {x.event.display_name == "" || x.event.display_name == null
                                                            ? x.event.complete_start_date
                                                            : x.event.display_name}
                                                            {/* <span className={`event-category ${fontSizeCategory(fontSizeOptions(item.font_size))} ${item.value.category_page.categories[0].name == '' ? "d-none" : ""}`}>| {item.value.category_page.categories[0].name}</span> */}
                                                          </p>

                                                          <p className={`text-left text-white event-description-historical font-style-3 2 ${fontSizeDesc(fontSizeOptions(x.font_size))}`}>
                                                            <div  dangerouslySetInnerHTML={{__html: x.event.description}} />
                                                          </p>
                                                        </div>
                                                      </div>

                                                      {x.event.photo == null || x.event.photo == "" ? "" :
                                                      <div className="col-xl-6 col-lg-4 col-md-6 col-sm-6 px-0">
                                                          <img className={`event-image pl-0 pt-2 pb-0 pr-0 d-block mx-auto ${x.image_display == 'left' ? '' : x.image_display == 'right' ? 'ml-auto' : x.image_display == 'center' ? 'mx-auto' : ''} ${ImageSizeOptions(x.image_size)}`} align="" src={x.event.photo.url} />
                                                      </div>
                                                      }
                                                  </div>
                                                  :
                                                  x.image_display == '' && x.text_display == 'under' ?
                                                  <div className="p-2" style={{filter: `${x.event_types == 'historical' ? 'none' : 'brightness(1.2)'}`, backgroundColor: `${x.event_types == 'historical' ? 'none' : props.timelinePeriod.period_color+60}`}}>
                                                    {x.event.photo == null || x.event.photo == "" ? "" :
                                                        <div className={`${x.image_display == 'd-block' ? '' : x.image_display == 'right' ? 'd-block' : x.image_display == 'center' ? 'd-block' : 'd-inline-block'}`}>
                                                          <img className={`event-image pl-0 pt-2 pb-0 pr-0 d-block ${x.image_display == 'left' ? '' : x.image_display == 'right' ? 'ml-auto' : x.image_display == 'center' ? 'mx-auto' : ''} ${ImageSizeOptions(x.image_size)}`} align="" src={x.event.photo.url} />
                                                        </div>
                                                      }
                                                    <p className={`mb-0 text-left text-gold-light event-title-historical ${fontSizeTitle(fontSizeOptions(x.font_size))} ${x.event.display_name == "" && x.event.complete_start_date == "" || 
                                                    x.event.display_name == null && x.event.complete_start_date == "" || x.event.complete_start_date == null? "d-none" : 
                                                    "d-block"}`}>
                                                        {x.event.display_name == "" || x.event.display_name == null
                                                          ? x.event.complete_start_date
                                                          : x.event.display_name}
                                                        </p>
                                                      <div>
                                                        <p className={`text-left text-white event-description-historical font-style-3 1 ${fontSizeDesc(fontSizeOptions(x.font_size))}`}>
                                                          <div  dangerouslySetInnerHTML={{__html: x.event.description}} />
                                                        </p>
                                                      </div>
                                                  </div>
                                                  :
                                                  <div className="p-2" style={{filter: `${x.event_types == 'historical' ? 'none' : 'brightness(1.2)'}`, backgroundColor: `${x.event_types == 'historical' ? 'none' : props.timelinePeriod.period_color+60}`}}>
                                                    <p className={`mb-0 text-left text-gold-light event-title-historical ${fontSizeTitle(fontSizeOptions(x.font_size))} ${x.event.display_name == "" && x.event.complete_start_date == "" || 
                                                    x.event.display_name == null && x.event.complete_start_date == "" || x.event.complete_start_date == null? "d-none" : 
                                                    "d-block"}`}>
                                                        {x.event.display_name == "" || x.event.display_name == null
                                                          ? x.event.complete_start_date
                                                          : x.event.display_name}
                                                        </p>
                                                      <div>
                                                        <p className={`text-left text-white event-description-historical font-style-3 1 ${fontSizeDesc(fontSizeOptions(x.font_size))}`}>
                                                          <div  dangerouslySetInnerHTML={{__html: x.event.description}} />
                                                        </p>
                                                      </div>
                                                      {x.event.photo == null || x.event.photo == "" ? "" :
                                                        <div className={`${x.image_display == 'd-block' ? '' : x.image_display == 'right' ? 'd-block' : x.image_display == 'center' ? 'd-block' : 'd-inline-block'}`}>
                                                          <img className={`event-image pl-0 pt-2 pb-0 pr-0 d-block ${x.image_display == 'left' ? '' : x.image_display == 'right' ? 'ml-auto' : x.image_display == 'center' ? 'mx-auto' : ''} ${ImageSizeOptions(x.image_size)}`} align="" src={x.event.photo.url} />
                                                        </div>
                                                      }
                                                  </div>
                                                }
                                              </div>
                                            </div> 
                                            : 
                                            <div className="mb-2 pl-5">
                                            <div className={`padding-05 pt-0 pl-5`}>
                                            {
                                              x.image_display == 'right' ?
                                              <div className="p-3 row" style={{filter: `${x.event_types == 'historical' ? 'none' : 'brightness(1.2)'}`, backgroundColor: `${x.event_types == 'historical' ? 'none' : props.timelinePeriod.period_color+60}`}}>
                                                  <div className={`${x.event.photo == null || x.event.photo == "" ? "col-md-12 px-0" : "col-xl-6 col-lg-8 col-md-6 col-sm-6 px-0 pr-1"}`}> 
                                                  <div className={`${x.event.photo == null || x.event.photo == "" ? 'p-0': x.text_display == 'under' ? 'pl-2 pt-1' :  x.text_display == 'bottom' ? 'p-3 position-absolute bottom-0' : x.text_display == 'center' ? 'p-2 top-25 position-absolute m-auto' : 'pb-1 pt-2 pl-2 pr-2'}`}>
                                                      <p className={`mb-0 text-left text-gold-light event-title-historical ${fontSizeTitle(fontSizeOptions(x.font_size))} ${x.event.display_name == "" && x.event.complete_start_date == "" || 
                                                        x.event.display_name == null && x.event.complete_start_date == "" || x.event.complete_start_date == null? "d-none" : 
                                                        "d-block"}`}>
                                                      {x.event.display_name == "" || x.event.display_name == null
                                                        ? x.event.complete_start_date
                                                        : x.event.display_name}
                                                        {/* <span className={`event-category ${fontSizeCategory(fontSizeOptions(item.font_size))} ${item.value.category_page.categories[0].name == '' ? "d-none" : ""}`}>| {item.value.category_page.categories[0].name}</span> */}
                                                      </p>

                                                      <p className={`text-left text-white event-description-historical font-style-3 2 right ${fontSizeDesc(fontSizeOptions(x.font_size))}`}>
                                                        <div  dangerouslySetInnerHTML={{__html: x.event.description}} />
                                                      </p>
                                                    </div>
                                                  </div>

                                                  {x.event.photo == null || x.event.photo == "" ? "" :
                                                  <div className="col-xl-6 col-lg-4 col-md-6 col-sm-6 px-0">
                                                      <img className={`event-image pl-0 pt-2 pb-0 pr-0 d-block mx-auto ${x.image_display == 'left' ? '' : x.image_display == 'right' ? 'ml-auto' : x.image_display == 'center' ? 'mx-auto' : ''} ${ImageSizeOptions(x.image_size)}`} align="" src={x.event.photo.url} />
                                                  </div>
                                                  }
                                              </div>
                                              :
                                              x.image_display == 'center' ?
                                              <div>
                                              {
                                                x.text_display == 'under' ?

                                                <div className="p-3 row" style={{filter: `${x.event_types == 'historical' ? 'none' : 'brightness(1.2)'}`, backgroundColor: `${x.event_types == 'historical' ? 'none' : props.timelinePeriod.period_color+60}`}}>
                                                  { x.event.photo == null || x.event.photo == "" ? "" :
                                                    <div className="px-0 mx-auto">
                                                        <img className={`event-image pl-0 pt-2 pb-0 pr-0 d-block mx-auto ${x.image_display == 'left' ? '' : x.image_display == 'right' ? 'ml-auto' : x.image_display == 'center' ? 'mx-auto' : ''} ${ImageSizeOptions(x.image_size)}`} align="" src={x.event.photo.url} />
                                                    </div>
                                                  }
                                                  <div className={`col-md-12 px-0`}> 
                                                    <div className={`${x.event.photo == null || x.event.photo == "" ? 'p-0' : 'pb-1 pt-2'}`}>
                                                      <p className={`mb-0 text-left text-gold-light event-title-historical ${x.text_display == 'left' ? 'text-left' : x.text_display == 'center' ? 'text-center' : x.text_display == 'right' ? 'text-right' : 'text-left'} ${fontSizeTitle(fontSizeOptions(x.font_size))} ${x.event.display_name == "" && x.event.complete_start_date == "" || 
                                                        x.event.display_name == null && x.event.complete_start_date == "" || x.event.complete_start_date == null? "d-none" : 
                                                        "d-block"}`}>
                                                      {x.event.display_name == "" || x.event.display_name == null
                                                        ? x.event.complete_start_date
                                                        : x.event.display_name}
                                                        {/* <span className={`event-category ${fontSizeCategory(fontSizeOptions(item.font_size))} ${item.value.category_page.categories[0].name == '' ? "d-none" : ""}`}>| {item.value.category_page.categories[0].name}</span> */}
                                                      </p>

                                                      <p className={`text-left text-white event-description-historical font-style-3 3 ${x.text_display == 'left' ? 'text-left' : x.text_display == 'center' ? 'text-center' : x.text_display == 'right' ? 'text-right' : 'text-left'} ${fontSizeDesc(fontSizeOptions(x.font_size))}`}>
                                                        <div  dangerouslySetInnerHTML={{__html: x.event.description}} />
                                                      </p>
                                                    </div>
                                                  </div>
                                                </div>
                                                :
                                                <div className="p-3 row top" style={{filter: `${x.event_types == 'historical' ? 'none' : 'brightness(1.2)'}`, backgroundColor: `${x.event_types == 'historical' ? 'none' : props.timelinePeriod.period_color+60}`}}>
                                                  <div className={`col-md-12 px-0`}> 
                                                    <div className={`${x.event.photo == null || x.event.photo == "" ? 'p-0' : 'pb-1 pt-0'}`}>
                                                      <p className={`mb-0 text-gold-light event-title-historical ${x.text_display == 'left' ? 'text-left' : x.text_display == 'center' ? 'text-center' : x.text_display == 'right' ? 'text-right' : 'text-left'} ${fontSizeTitle(fontSizeOptions(x.font_size))} ${x.event.display_name == "" && x.event.complete_start_date == "" || 
                                                        x.event.display_name == null && x.event.complete_start_date == "" || x.event.complete_start_date == null? "d-none" : 
                                                        "d-block"}`}>
                                                      {x.event.display_name == "" || x.event.display_name == null
                                                        ? x.event.complete_start_date
                                                        : x.event.display_name}
                                                        {/* <span className={`event-category ${fontSizeCategory(fontSizeOptions(item.font_size))} ${item.value.category_page.categories[0].name == '' ? "d-none" : ""}`}>| {item.value.category_page.categories[0].name}</span> */}
                                                      </p>

                                                      <p className={`text-left text-white event-description-historical font-style-3 4 ${x.text_display == 'left' ? 'text-left' : x.text_display == 'center' ? 'text-center' : x.text_display == 'right' ? 'text-right' : 'text-left'} ${fontSizeDesc(fontSizeOptions(x.font_size))}`}>
                                                        <div  dangerouslySetInnerHTML={{__html: x.event.description}} />
                                                      </p>
                                                    </div>
                                                  </div>
                                                  { x.event.photo == null || x.event.photo == "" ? "" :
                                                    <div className="px-0 mx-auto">
                                                        <img className={`event-image pl-0 pt-2 pb-0 pr-0 d-block mx-auto ${ImageSizeOptions(x.image_size)}`} align="" src={x.event.photo.url} />
                                                    </div>
                                                  }
                                                </div>
                                              }
                                              </div>
                                              :
                                              <div>
                                                  {
                                                    x.text_display == 'under' ?

                                                    <div className="p-3 row" style={{filter: `${x.event_types == 'historical' ? 'none' : 'brightness(1.2)'}`, backgroundColor: `${x.event_types == 'historical' ? 'none' : props.timelinePeriod.period_color+60}`}}>
                                                      { x.event.photo == null || x.event.photo == "" ? "" :
                                                        <div className="px-0">
                                                            <img className={`event-image pl-0 pt-2 pb-0 pr-0 d-block mx-auto ${x.image_display == 'left' ? '' : x.image_display == 'right' ? 'ml-auto' : x.image_display == 'center' ? 'mx-auto' : ''} ${ImageSizeOptions(x.image_size)}`} align="" src={x.event.photo.url} />
                                                        </div>
                                                      }
                                                      <div className={`col-md-12 px-0`}> 
                                                        <div className={`${x.event.photo == null || x.event.photo == "" ? 'p-0' : 'pb-1 pt-2'}`}>
                                                          <p className={`mb-0 text-left text-gold-light event-title-historical ${fontSizeTitle(fontSizeOptions(x.font_size))} ${x.event.display_name == "" && x.event.complete_start_date == "" || 
                                                            x.event.display_name == null && x.event.complete_start_date == "" || x.event.complete_start_date == null? "d-none" : 
                                                            "d-block"}`}>
                                                          {x.event.display_name == "" || x.event.display_name == null
                                                            ? x.event.complete_start_date
                                                            : x.event.display_name}
                                                            {/* <span className={`event-category ${fontSizeCategory(fontSizeOptions(item.font_size))} ${item.value.category_page.categories[0].name == '' ? "d-none" : ""}`}>| {item.value.category_page.categories[0].name}</span> */}
                                                          </p>

                                                          <p className={`text-left text-white event-description-historical font-style-3 5 ${fontSizeDesc(fontSizeOptions(x.font_size))}`}>
                                                            <div  dangerouslySetInnerHTML={{__html: x.event.description}} />
                                                          </p>
                                                        </div>
                                                      </div>
                                                    </div>

                                                    :

                                                    x.text_display == 'above' ?

                                                    <div className="p-3 row top" style={{filter: `${x.event_types == 'historical' ? 'none' : 'brightness(1.2)'}`, backgroundColor: `${x.event_types == 'historical' ? 'none' : props.timelinePeriod.period_color+60}`}}>
                                                      <div className={`col-md-12 px-0`}> 
                                                        <div className={`${x.event.photo == null || x.event.photo == "" ? 'p-0' : 'pb-1 pt-0'}`}>
                                                          <p className={`mb-0 text-left text-gold-light event-title-historical ${fontSizeTitle(fontSizeOptions(x.font_size))} ${x.event.display_name == "" && x.event.complete_start_date == "" || 
                                                            x.event.display_name == null && x.event.complete_start_date == "" || x.event.complete_start_date == null? "d-none" : 
                                                            "d-block"}`}>
                                                          {x.event.display_name == "" || x.event.display_name == null
                                                            ? x.event.complete_start_date
                                                            : x.event.display_name}
                                                            {/* <span className={`event-category ${fontSizeCategory(fontSizeOptions(item.font_size))} ${item.value.category_page.categories[0].name == '' ? "d-none" : ""}`}>| {item.value.category_page.categories[0].name}</span> */}
                                                          </p>

                                                          <p className={`text-left text-white event-description-historical font-style-3 6 ${fontSizeDesc(fontSizeOptions(x.font_size))}`}>
                                                            <div  dangerouslySetInnerHTML={{__html: x.event.description}} />
                                                          </p>
                                                        </div>
                                                      </div>
                                                      { x.event.photo == null || x.event.photo == "" ? "" :
                                                        <div className="px-0">
                                                            <img className={`event-image pl-0 pt-2 pb-0 pr-0 d-block mx-auto ${x.image_display == 'left' ? '' : x.image_display == 'right' ? 'ml-auto' : x.image_display == 'center' ? 'mx-auto' : ''} ${ImageSizeOptions(x.image_size)}`} align="" src={x.event.photo.url} />
                                                        </div>
                                                      }
                                                    </div>

                                                    :

                                                    <div className="p-3 row xx" style={{filter: `${x.event_types == 'historical' ? 'none' : 'brightness(1.2)'}`, backgroundColor: `${x.event_types == 'historical' ? 'none' : props.timelinePeriod.period_color+60}`}}>
                                                      { x.event.photo == null || x.event.photo == "" ? "" :
                                                        <div className="">
                                                        {/* <div className="col-xl-6 col-lg-4 col-md-6 col-sm-6 px-0"> */}
                                                            <img className={`event-image pl-0 pt-2 pb-0 pr-0 d-block mx-auto ${x.image_display == 'left' ? '' : x.image_display == 'right' ? 'ml-auto' : x.image_display == 'center' ? 'mx-auto' : ''} ${ImageSizeOptions(x.image_size)}`} align="" src={x.event.photo.url} />
                                                        </div>
                                                      }
                                                      <div className=""> 
                                                      {/* <div className={`${x.event.photo == null || x.event.photo == "" ? "col-md-12 px-0" : "col-xl-6 col-lg-8 col-md-6 col-sm-6 px-0 pr-1"}`}>  */}
                                                        <div className={`${x.event.photo == null || x.event.photo == "" ? 'p-0' : x.text_display == 'bottom' ? 'p-3 position-absolute bottom-0' : x.text_display == 'center' ? 'p-2 top-25 position-absolute m-auto' : 'pb-1 pt-2 pl-2'}`}>
                                                          <p className={`mb-0 text-left text-gold-light event-title-historical ${fontSizeTitle(fontSizeOptions(x.font_size))} ${x.event.display_name == "" && x.event.complete_start_date == "" || 
                                                            x.event.display_name == null && x.event.complete_start_date == "" || x.event.complete_start_date == null? "d-none" : 
                                                            "d-block"}`}>
                                                          {x.event.display_name == "" || x.event.display_name == null
                                                            ? x.event.complete_start_date
                                                            : x.event.display_name}
                                                            {/* <span className={`event-category ${fontSizeCategory(fontSizeOptions(item.font_size))} ${item.value.category_page.categories[0].name == '' ? "d-none" : ""}`}>| {item.value.category_page.categories[0].name}</span> */}
                                                          </p>

                                                          <p className={`text-left text-white event-description-historical font-style-3 7 ${fontSizeDesc(fontSizeOptions(x.font_size))}`}>
                                                            <div  dangerouslySetInnerHTML={{__html: x.event.description}} />
                                                          </p>
                                                        </div>
                                                      </div>
                                                    </div>
                                                  }
                                              </div>
                                            }
                                          </div>
                                      </div>
                                      }
                                    </Link>
                                </div>
                              </div>
                              </div>
                               {/* )
                             }) */}
                          {/* } */}
                          </GridColumn>

                         </Grid>
                            </div>
                          }
                        </div>
                      )
                    })}
                  </div>
                )
              })
            }
					  </div>
          )
        })}
				</div>
			</div>
		</div>

	</div>
</section>
 

</div>
)
};
